import styled from 'styled-components';

interface BadgeWrapperProps {
  r: number;
  g: number;
  b: number;
  color: string;
}
export const BadgeWrapper = styled.div<BadgeWrapperProps>`
  height: 18px;
  padding: 3px 4px 3px 4px;
  border-radius: 4px;
  color: ${(props) => props.color};
  background: rgba(
    ${(props) => props.r},
    ${(props) => props.g},
    ${(props) => props.b},
    1
  );

  font-family: Montserrat;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
`;
